import React from "react";
import { useTranslation } from "react-i18next";

import { ExerciseId } from "../types";
import { useFavouritesAndExcluded } from "../utils/useFavouritesAndExcluded";
import ExercisesEditList from "./ExercisesEditList";

const ExcludedList: React.FC = () => {
    const { t } = useTranslation();
    const { excluded, setExcluded } = useFavouritesAndExcluded();

    const handleDeleteClick = (id: ExerciseId) => {
        setExcluded(id, false);
    };

    return (
        <ExercisesEditList header={t("excluded")} noExercisePlaceholder={t("no_excluded_exercises")} ids={excluded} onDelete={handleDeleteClick} />
    );
};

export default ExcludedList;
